import {
  Account,
  AccountPlanType,
} from '../../components/Search/SearchNav/types';
import {UsageType} from '../../generated/graphql';
import {useAccountPrivileges} from '../accounts/pricing';
import {useRampReinforcementLearningAsProduct} from '../rampFeatureFlags';
import {
  getIntervalMarkersFromCurrentCalendarMonth,
  getIntervalMarkersFromLimitDateInterval,
  useGetUsageThisBillingPeriod,
} from './utils';

export function useGetTrainingUsageDetails(selectedAccount: Account | null) {
  const skip =
    selectedAccount?.name == null ||
    selectedAccount?.accountPlanType === AccountPlanType.Personal;

  const privilegeResults = useAccountPrivileges(selectedAccount);
  const {
    privileges: {trainingLimits, trainingLimitDateInterval},
  } = privilegeResults;

  // TODO: In the future we would check for the existence of a stripe or orb subscription
  const isUsagePaid = false;

  const calendarMonth = getIntervalMarkersFromCurrentCalendarMonth();

  const finalLimitDateInterval =
    selectedAccount?.accountPlanType === AccountPlanType.Enterprise
      ? getIntervalMarkersFromLimitDateInterval(trainingLimitDateInterval)
      : calendarMonth;

  const shouldUseTrainingCost = useRampReinforcementLearningAsProduct();

  const usageResults = useGetUsageThisBillingPeriod(
    selectedAccount,
    shouldUseTrainingCost ? UsageType.TrainingCost : UsageType.TrainingDuration,
    finalLimitDateInterval,
    skip
  );

  const loading = usageResults.loading;
  const error = usageResults.error;
  const [billingPeriodStart, billingPeriodEnd] = finalLimitDateInterval;
  const {usage} = usageResults;

  return {
    isUsagePaid,
    trainingLimits,
    billingPeriodStart,
    billingPeriodEnd,
    usage,
    loading,
    error,
  };
}
